import React, { Component } from 'react';
import Header from 'components/Header/index';
import Dashboard from 'pages/Dashboard'

class App extends Component {
  render() {
    return (
      <div className="App container">
        <Header />
        <Dashboard />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/App/index.js